<template lang="pug">
v-container
  h1 Обработанные письма
  v-divider
  v-row.ma-0(v-if="loading")
    v-progress-circular.ma-auto(
      :width="5"
      color="primary"
      :size="50"
      indeterminate
    )
  v-list(v-else)
    v-list-item.mb-2(v-for="(item, idx) in history" :key="idx").grey.lighten-4
      v-list-item-content
        v-list-item-title.primary--text: strong {{ item.email }}
        v-list-item-subtitle Всего:
          span.ml-2: strong {{ item.value.length }}
        v-list-item-subtitle
          v-chip-group(show-arrows)
            v-chip(v-for="(chip, index) in item.value" :key="index") {{ chip }}
  v-alert(v-if="!history.length && !loading" type="info") Нет обаботанных писем
  //- smart-table(
  //-   :headers="headers"
  //-   :adapter="adapter"
  //-   hide-search-actions
  //-   hide-expand
  //- )
</template>
<script>
import service from '@/services/API/letter-handler';
import SmartTable from '@/components/SmartTable/index.vue';

export default {
  name: 'AutoAnsewerSettings',
  components: {
    SmartTable,
  },
  data() {
    return {
      selectedTab: 0,
      history: [],
      node: [],
      loading: true,
    };
  },
  created() {
    this.getHistory();
    // this.getNode();
  },

  methods: {
    // async getNode() {
    //   const { data } = await service.getNodeStatus();
    //   this.node = data.data;
    // },

    async getHistory() {
      const { data } = await service.getNodeHistory();
      const result = Object.entries(data.data).map(([key, value]) => ({ email: key, value }));
      this.history = result;
      this.loading = false;
    },
  },
};
</script>
